import { ReactElement } from 'react';
import { Link, useParams } from 'react-router-dom';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import styles from './styles.module.scss';

import EmptyBox from ':images/errors/empty_box.png';
import EmptyBox2x from ':images/errors/empty_box@2x.png';
import EmptyBox3x from ':images/errors/empty_box@3x.png';

export function WidgetsEmpty(): ReactElement {
  const { employeeNumber } = useParams();

  return (
    <div className={styles.empty}>
      <img
        src={EmptyBox}
        alt='ошибка'
        srcSet={`${EmptyBox2x} 2x, ${EmptyBox3x} 3x`}
        className={styles.emptyImg}
      />
      <div className={styles.content}>
        <Typography className={styles.title} variant='h6'>
          Сейчас нет никакой информации от сервисов кабинета сотрудника
        </Typography>
        <Typography variant='body2' className={styles.subtitle}>
          Корпоративные сервисы публикуют здесь актуальную информацию о текущих
          заявках
        </Typography>
      </div>
      {!employeeNumber && (
        <Link to='/catalog' className={styles.link}>
          <Typography variant='subtitle2' className={styles.linkText}>
            Перейти в Каталог сервисов
          </Typography>
        </Link>
      )}
    </div>
  );
}
